import { render, staticRenderFns } from "./EvaluationResume.vue?vue&type=template&id=b41f58d6&"
import script from "./EvaluationResume.vue?vue&type=script&lang=js&"
export * from "./EvaluationResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports